export default __webpack_public_path__ + "static/media/box_gray.e4a1b923.svg";